export const sideNavKeys = {
  all: ["sideNav"] as const,
  currentUserRoles: () => [...sideNavKeys.all, "currentUserRoles"] as const,
};
